// extracted by css-extract-rspack-plugin
export default {"container":"AgentSuggestionsIndicator-module__container__rVxnJ"};